export const totalAtualOrcamentoBrl = (plano = {}) => {
    const possuiBrl = plano.total_atual_orcamento_brl !== null && plano.total_atual_orcamento_brl !== undefined && plano.total_atual_orcamento_brl !== '';
    const valor = Number(possuiBrl ? plano.total_atual_orcamento_brl : plano.total_atual_orcamento);
    return Number.isFinite(valor) ? valor : 0;
};

// Coluna do orçamento (Rafael, 06/10): o nome salvo pelo Eventos (`orcamento.titulo`). Sem nome
// (orçamento antigo / não preenchido), cai no "Orç. #código" de antes.
export const nomeOrcamentoDaLinha = (plano = {}) => {
    const titulo = plano && plano.orcamento_titulo ? String(plano.orcamento_titulo).trim() : '';
    if (titulo) return titulo;
    return plano && plano.orcamento_codigo ? 'Orç. #' + plano.orcamento_codigo : '—';
};

// Coluna de data do Custo Previsto / Aprovados (Rafael, 06/10): mostra a data de cada parcela
// que está NESTA linha. Não usa `data_previsao_pagamento` do plano — em plano antigo (antes de
// 04/08) ela é a data digitada à mão no plano, que não bate com as parcelas.
export const datasParcelasDaLinha = (plano = {}) => {
    const datas = ((plano && plano.parcelas) || [])
        .map(p => p && p.data_pagamento)
        .filter(Boolean)
        .map(d => String(d).slice(0, 10));
    return [...new Set(datas)].sort();
};

// Aprovados pelo Financeiro (Rafael, 06/10): a linha continua sendo o fornecedor (aprovar vale para
// todas as parcelas dele), e a coluna Data mostra cada parcela com a forma de pagamento escolhida —
// como a aba de Planos já mostra. Uma parcela por linha é no Contas Pendentes.
export const parcelasDataFormaDaLinha = (plano = {}) => ((plano && plano.parcelas) || [])
    .filter(p => p && p.data_pagamento)
    .map(p => ({ data: String(p.data_pagamento).slice(0, 10), forma: p.forma || '' }))
    .sort((a, b) => (a.data < b.data ? -1 : a.data > b.data ? 1 : 0));

// Modal "Aprovar Plano de Pagamento" (Rafael, 06/10): o aviso dizia que o título seria criado mesmo
// com o fornecedor marcado "não vai para Contas a Pagar" (a API aprova sem título nesse caso).
// Campo ausente (API antiga) = vai para Contas a Pagar, como antes.
export const vaiParaContasPagar = (plano = {}) => !(plano && plano.vai_contas_pagar === false);
